// Axios instance and types
import http from '../api'
import { Filters, APIPaginatedResponse, Pagination, APIResponse } from '../types'
import { getRequestParamString } from '../utils/utils'
import type { TypeBranch } from '../../types/Branch'
import type { InventoryLocationApi } from '../../modules/inventory/services/locations'

const apiPath = import.meta.env.VITE_API_PATH

async function getUserActiveBusinesses(filters?: Partial<Filters>, pagination?: Partial<Pagination>) {
  return await http.get<APIPaginatedResponse<any>>(
    apiPath + 'business/active/user-active-business' + getRequestParamString(filters, pagination),
  )
}

async function getUserBusinesses(filters?: Partial<Filters>, pagination?: Partial<Pagination>) {
  return await http.get<APIPaginatedResponse<any>>(apiPath + 'business' + getRequestParamString(filters, pagination))
}

async function switchActiveBusiness(businessUuid: string) {
  return await http.post<APIResponse<any>>(`${apiPath}business/active/switch-active-business/${businessUuid}`)
}

/** Allow-listed branches for context selection (no branch-manage permission required). */
async function getSelectableBranches() {
  return await http.get<{ data: TypeBranch[] }>(`${apiPath}business/active/branches`, {
    errorHandle: false,
  } as any)
}

async function setActiveBranch(branchUuid: string) {
  return await http.post<any>(`${apiPath}business/active/branch`, { branch_uuid: branchUuid }, {
    errorHandle: false,
  } as any)
}

/** Allow-listed locations for the active session branch (server-scoped). */
async function getSelectableInventoryLocations() {
  return await http.get<{ data: InventoryLocationApi[] }>(`${apiPath}business/active/inventory-locations`, {
    errorHandle: false,
  } as any)
}

async function setActiveInventoryLocation(locationId: number) {
  return await http.post<any>(`${apiPath}business/active/inventory-location`, { location_id: locationId }, {
    errorHandle: false,
  } as any)
}

async function unSetActiveBusiness() {
  return await http.post<APIResponse<any>>(`${apiPath}business/active/unset-active-business`)
}

export default {
  getUserActiveBusinesses,
  getUserBusinesses,
  switchActiveBusiness,
  getSelectableBranches,
  setActiveBranch,
  getSelectableInventoryLocations,
  setActiveInventoryLocation,
  unSetActiveBusiness,
}
